import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tag-input__recipient-message"
}
const _hoisted_2 = {
  key: 0,
  class: "tag-input__tags"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 1,
  class: "tag-input__instructions"
}
const _hoisted_6 = {
  key: 2,
  class: "tag-input__error-message"
}
const _hoisted_7 = {
  key: 3,
  class: "filtered-selector__suggestions"
}
const _hoisted_8 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hadrianLabel = _resolveComponent("hadrianLabel")!
  const _component_iconRemoveTag = _resolveComponent("iconRemoveTag")!
  const _component_hadrianLoader = _resolveComponent("hadrianLoader")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.recipientMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.recipientMessage), 1))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["tag-input", { 'tag-input--invalid': !_ctx.isValid }])
    }, [
      (_ctx.label)
        ? (_openBlock(), _createBlock(_component_hadrianLabel, {
            key: 0,
            text: _ctx.label,
            mandatory: _ctx.mandatory,
            helpTooltip: _ctx.helpTooltip
          }, null, 8, ["text", "mandatory", "helpTooltip"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "tag-input__input-container",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args)))
      }, [
        (_ctx.selectedValues.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedValues, (tag, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${tag}-${index}`,
                  class: _normalizeClass(["tag-input__tag", { 'tag-input__tag--invalid': _ctx.validator && !_ctx.validator(tag) }])
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getLabel(tag)), 1),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _withModifiers(($event: any) => (_ctx.removeTag(index)), ["stop"]),
                    "aria-label": "Delete"
                  }, [
                    _createVNode(_component_iconRemoveTag)
                  ], 8, _hoisted_3)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("input", {
          ref: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
          class: "tag-input__input",
          placeholder: _ctx.placeholder,
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
          onKeyup: [
            _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onDeleteKeyPress && _ctx.onDeleteKeyPress(...args)), ["delete"])),
            _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.addCustomTag && _ctx.addCustomTag(...args)), ["prevent"]), ["enter"])),
            _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args)))
          ],
          onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSuggestions = true))
        }, null, 40, _hoisted_4), [
          [_vModelText, _ctx.input]
        ]),
        _createVNode(_component_hadrianLoader, {
          isLoading: _ctx.showLoading,
          semiTransparent: ""
        }, null, 8, ["isLoading"])
      ]),
      (!!_ctx.instructions)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.instructions), 1))
        : _createCommentVNode("", true),
      (!!_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true),
      (_ctx.showSuggestions && _ctx.filteredSuggestions.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSuggestions, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.value,
                class: "filtered-selector__suggestion",
                onMousedown: _withModifiers(($event: any) => (_ctx.selectSuggestion(item)), ["prevent"])
              }, _toDisplayString(item.label), 41, _hoisted_8))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2)), [
      [_directive_click_outside, _ctx.hideSuggestions]
    ])
  ], 64))
}